import * as React from 'react'

import { cn } from '../../lib/cn'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          // Browser autofill overrides (Chromium / Comet) — Chromium paints a
          // 1000px inset box-shadow + its own text fill on autofilled fields,
          // overriding `bg-background` / `text-foreground` from the cascade.
          // Reapply our brand surface + text color via the same mechanism the
          // browser uses.
          'autofill:shadow-[inset_0_0_0_1000px_var(--color-input)]',
          '[&:-webkit-autofill]:[-webkit-text-fill-color:var(--color-foreground)]',
          '[&:-webkit-autofill]:[caret-color:var(--color-foreground)]',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }